export default __webpack_public_path__ + "static/media/9-Uranus.8db0c61d.svg";